<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      edit-title
      unit="违纪处理"
      id-key="StayRegId"
      :data="data"
      form-label-width="80px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="处理结果" prop="HandleRemark">
              <el-input size="mini" v-model="data.HandleRemark" placeholder="请填写处理结果" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="处理时间" prop="HandleTime">
              <el-date-picker
              v-model="data.HandleTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="处理时间"
              style="width:100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件" prop="FileUrl">
            <import-file
              :upload-url="api.UploadFileUrl"
              :subData="subData"
              text="上传附件"
              w="80px"
              :btntype="true"
              single
              @on-uploaded="uploaded"
              :uploadFiles="uploadedFiles"
            />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));

import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import importFile from "@/components/common/files/importFile";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    importFile
  },
  data() {
    return {
      api: require("@/api/attendance/disviolation").default,
      data: {
        DisciplineViolationId: 0,
        TermId: 0,
        StudentId: 0,
        HandleRemark: "",
        HandleTime: this.$commonJs.getNowDatetimeString(),
        FileName: "",
        FileUrl: "",
        AddTeacherId: loginInfo.UserId,
      },
      ids: [],
      subData: {},
      uploadedFiles: [],
      isMB: this.$store.state.isMB,
      rules: {
        HandleRemark: [{ required: true, message: "请填写处理结果" }],
        HandleTime: [{ required: true, message: "请选择处理时间" }],
      },
    };
  },
  methods: {
    onCreateOpened(data) {
      this.ids = data.ids;
    },
    onEditOpened() {
    },
    uploaded(res, fileList) {
      // console.log("uploaded", res, fileList);
      this.data.FileName = res.Data.FileName + "." + res.Data.Extension;
      this.data.FileUrl = res.Data.VirtualPath;
    },
    onBeforeSave(data) {
      var sub = [];
      this.ids.forEach(id => {
        sub.push({
          ...this.data,
          TermId: localStorage.getItem("quaTerm"),
          StudentId: id,
          Violation: true
        })
      })
      // console.log("sub",sub)
      // return false;
      this.loading(true);
      this.api.saveList(sub).then(res => {
        this.loading(false);
        if(res.Code==0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit('close-saved');
        } else {
          this.$message.error(res.Msg);
        }
      }).catch(() => {
        this.loading(false);
      })
      return false;
    },
    onClosed() {
      this.ids = [];
      this.uploadedFiles = [];
    },
  },
};
</script>
<style lang="scss">
</style>